import { render, staticRenderFns } from "./PtspPayWithTransfer.vue?vue&type=template&id=d9002a50&scoped=true"
import script from "./PtspPayWithTransfer.vue?vue&type=script&lang=js"
export * from "./PtspPayWithTransfer.vue?vue&type=script&lang=js"
import style0 from "./PtspPayWithTransfer.vue?vue&type=style&index=0&id=d9002a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9002a50",
  null
  
)

export default component.exports